import { auditTypeList } from './request';
import { columns, pagination } from './utils';
import addModal from './addModal.vue';
export default {
  components: {
    addModal
  },
  data() {
    return {
      columns,
      pagination,
      form: {
        name: ''
      },
      tableData: [],
      addVisible: false,
      isEdit: false
    };
  },
  created() {
    this.searchFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = this.pagination.page = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await auditTypeList(Object.assign(this.form, {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.page -= 1;
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    openAddModal(value) {
      this.isEdit = value;
      this.addVisible = true;
    },
    tablePageChange(val) {
      this.pagination = val;
      this.pagination.page = val.current;
      this.getListData();
    }
  }
};